module.exports = __webpack_public_path__ + "img/DAY5-2.aa4c439f.jpg";